module.exports = __webpack_public_path__ + "static/innovation_img@2x-4490ff0901ec1f46c8b8891b77d66d00.png";